module.exports = __webpack_public_path__ + "static/media/tick-container.a2ecc386.svg";